import { TRecordAny } from "../../global.types";
import { TabIndex } from "@utils/general";

export const getTabIndex = (props: TRecordAny) => {
    return props.auditTrailData ? TabIndex.Disabled : TabIndex.NormalOrder;
};